import React, { useState } from 'react';
import './LogDetailModal.css';
import { MaintenanceLogType } from '../interfaces/MaintenanceLogType';
import ConfirmDialog from './ConfirmDialog';
import {
  saveMaintenanceLog,
  deleteMaintenanceLog,
} from '../firebase/db-maintenanceLogs';
import { UserType } from '../interfaces/SettingsType';

interface MaintenanceRepairDetailModalProps {
  log: MaintenanceLogType | null;
  onClose: (log?: MaintenanceLogType) => void;
  isAdmin: boolean;
  pilots: UserType[];
}

const MaintenanceRepairDetailModal: React.FC<
  MaintenanceRepairDetailModalProps
> = ({ log, onClose, isAdmin, pilots }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentLog, setCurrentLog] = useState<MaintenanceLogType>(
    log || {
      logId: Date.now().toString(),
      createdBy: pilots[0].email || 'N/A',
      date: new Date(),
      comment: '',
      droneType: '',
      maintenanceType: '',
      errors: '',
    }
  );

  const handleSave = async () => {
    await saveMaintenanceLog(currentLog);
    onClose(currentLog);
  };

  const [selectedAnalyst, setSelectedAnalyst] = useState(
    log?.createdBy || 'N/A'
  );

  const handleAnalystChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedAnalyst(event.target.value);
    setCurrentLog({ ...currentLog, createdBy: event.target.value });
  };

  const handleDelete = async () => {
    if (log) {
      await deleteMaintenanceLog(log.logId);
      onClose(undefined);
    }
  };

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = event.target;
    setCurrentLog((prevLog) => ({ ...prevLog, [name]: value }));
  };

  return (
    <div className="modal-overlay" onClick={() => onClose(currentLog)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="button-container">
          {log && isAdmin && (
            <>
              <button
                className="modal-button material-icons delete-button"
                onClick={() => setShowConfirm(true)}
              >
                delete
              </button>
              {showConfirm && (
                <ConfirmDialog
                  message="Willst du dieses Wartungs-Log wirklich löschen?"
                  onConfirm={handleDelete}
                  onCancel={() => setShowConfirm(false)}
                />
              )}

<button
            className="modal-button material-icons save-button-modal"
            onClick={handleSave}
          >
            save
          </button>
            </>
          )}
          {!log && (
            <>
              <button
            className="modal-button material-icons save-button-modal"
            onClick={handleSave}
          >
            save
          </button>
            </>
          )}
          
          <button
            className="modal-button material-icons close-button"
            onClick={() => onClose(currentLog)}
          >
            close
          </button>
        </div>

        <div className="modal-header">
          <h2>{log ? 'Wartungs-Log bearbeiten' : 'Neues Wartungs-Log'}</h2>
        </div>
        <div className="modal-body">
          <div className="modal-left">
            <div className="modal-details">
              <div className="modal-group">
                <div>
                  <strong>Erstellt von:</strong>
                  <select
                    name="createdBy"
                    value={selectedAnalyst}
                    onChange={handleAnalystChange}
                  >
                    {pilots.map((pilot) => (
                      <option key={pilot.email} value={pilot.email}>
                        {pilot.prename + ' ' + pilot.lastname}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="modal-input-small-date">
                  <strong>Datum:</strong>
                  <input
                    className="modal-input-small-date-inside"
                    type="date"
                    name="date"
                    value={
                      currentLog.date
                        ? currentLog.date.toISOString().split('T')[0]
                        : ''
                    }
                    onChange={(e) => {
                      try {
                        const date = new Date(e.target.value);
                        console.log(date.toISOString().split('T')[0]);
                        setCurrentLog({
                          ...currentLog,
                          date: date,
                        });
                      } catch (e) {
                        console.warn(e);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="modal-group">
                <div>
                  <strong>Drohnen-Typ:</strong>
                  <select
                    name="droneType"
                    value={currentLog.droneType}
                    onChange={handleChange}
                  >
                    <option value="">Bitte wählen</option>
                    <option value="DJI Matrice 350 RTK">
                      DJI Matrice 350 RTK
                    </option>
                    <option value="DJI Mavic 2EA">DJI Mavic 2EA</option>
                    <option value="Andere">Andere</option>
                  </select>
                </div>
                <div>
                  <strong>Wartungs-Typ:</strong>
                  <select
                    name="maintenanceType"
                    value={currentLog.maintenanceType}
                    onChange={handleChange}
                  >
                    <option value="">Bitte wählen</option>
                    <option value="Software-Update">Software-Update</option>
                    <option value="Funktions-Test">Funktions-Test</option>
                    <option value="Motorprüfung">Motorprüfung</option>
                    <option value="Akku-Wartung">Akku-Wartung</option>
                    <option value="Sensor-Kalibrierung">
                      Sensor-Kalibrierung
                    </option>
                    <option value="Sonstiges">Sonstiges</option>
                  </select>
                </div>
              </div>
              <div className="modal-group modal-group-full">
                <div>
                  <strong>Fehlermeldungen:</strong>
                  <textarea
                    className="remarks-input"
                    name="errors"
                    rows={3}
                    value={currentLog.errors}
                    onChange={handleChange}
                    placeholder="Fehlermeldungen eintragen (falls vorhanden)"
                  />
                </div>
              </div>
              <div className="modal-group modal-group-full">
                <div>
                  <strong>Kommentar:</strong>
                  <textarea
                    className="remarks-input"
                    name="comment"
                    rows={4}
                    value={currentLog.comment}
                    onChange={handleChange}
                    placeholder="Zusätzliche Informationen zur Wartung"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceRepairDetailModal;
